import React from 'react';
import PropTypes from 'prop-types';

const IdeaPage = ({ children }) => (
  <div
    className="flex flex-col items-center pt-3 sm:pt-12 w-full"
    data-testid="idea_page"
  >
    {children}
  </div>
);

IdeaPage.propTypes = {
  children: PropTypes.node
};

export default IdeaPage;
